






































import { Component, Mixins } from "vue-property-decorator";
import RectangleDragHandles from "../../../dragging/RectangleDragHandles.vue";
import {
  DraggableShapeDrawableObjectMixin,
  CircleDrawableMixin
} from "./mixins";
import TexturePattern from "./TexturePattern.vue";
import { IKeyboardEventHandleable } from "..";
import { KeyCodeProcessor } from "./KeyCodeProcessor";

@Component({
  components: {
    TexturePattern,
    RectangleDragHandles,
  },
})
export default class CircleObject extends Mixins(
  DraggableShapeDrawableObjectMixin,
  CircleDrawableMixin
) implements IKeyboardEventHandleable {
  handleKeyboardEvent(event: KeyboardEvent): boolean {
    if (!this.editingSource.isEditable) {
      return false;
    }
    const moveOffset = KeyCodeProcessor.toMoveOffset(event.keyCode);
    if (moveOffset) {
      this.writeProperty(s => s.geometry.rectangle = s.geometry.rectangle.move(moveOffset));
      return true;
    }
    return false;
  }
}
